export const hrGuideSections = [
  {
    title: "Purpose of the HR module",
    content:
      "HR modul je centralni sistem za upravljanje ljudima i organizacionom strukturom. Njegova svrha je da definiše osobe, njihove angažmane, pozicije i veze sa projektima. HR ne upravlja pristupima – već obezbeđuje osnovne podatke za IT access sistem."
  },
  {
    title: "Core entities",
    content:
      "Ključni entiteti su: hr_people, hr_employment, hr_departments, hr_teams, hr_positions, hr_notes, hr_documents i project_resource_assignments."
  },
  {
    title: "How organization works",
    content:
      "Organizaciona struktura se definiše kroz department → team → position hijerarhiju. Osoba se vezuje za poziciju kroz employment zapis, što omogućava praćenje istorije promena."
  },
  {
    title: "How access works (important)",
    content:
      "HR modul ne upravlja pristupima direktno. Osoba dobija poziciju u HR-u, a zatim IT sistem dodeljuje role toj poziciji. Role se mapiraju na policy-je, a policy-ji definišu permission-e. Na taj način user dobija pristup indirektno kroz svoju poziciju."
  },
  {
    title: "Position as single source of truth",
    content:
      "Pozicija je ključni element sistema. Ona povezuje HR i IT: HR definiše ko je na kojoj poziciji, a IT definiše šta ta pozicija znači u smislu pristupa i ovlašćenja."
  },
  {
    title: "How project assignments work",
    content:
      "Osoba iz HR modula može biti dodeljena projektu kroz project_resource_assignments. Za svaki assignment definišu se projekat, osoba, uloga na projektu, procenat angažovanja, period i status."
  },
  {
    title: "Current integration logic",
    content:
      "HR modul je povezan sa ostatkom platforme kroz user_id i position assignments. Ovi podaci se koriste u IT access sistemu za automatsko određivanje pristupa, kao i u CRM i projekt modulima za dodelu zadataka i resursa."
  },
  {
    title: "Recommended usage order",
    content:
      "Preporučeni redosled rada je: 1) departments, 2) teams, 3) positions, 4) people, 5) employment, 6) project assignments. Access prava se ne dodeljuju u HR-u već u IT panelu."
  },
  {
    title: "What is managed in IT module",
    content:
      "IT modul upravlja pristupima kroz sledeći tok: position → role → policy → permission. HR samo definiše strukturu i pripadnost pozicijama."
  },
  {
    title: "Recommended next steps",
    content:
      "Dalji razvoj uključuje org chart prikaz, bolju vizualizaciju povezanosti HR i IT sistema, kao i automatizaciju dodele taskova i notifikacija na osnovu pozicije i uloge."
  }
];